import { IPageMetaData, IPageProperty, IViewProperty, NavGridVisibility } from '../nav';
import { INavEditContext, INavPageClientInfo, NavPageClientInfo, NavPageMetaData, NavPropertyItems, NavPropertyValue, IObservableArray } from '../navdata';
import { CreateCounter, fn, INamed } from '../utils';
import { Bind, constants as kconstants, GetGridDataSource, NavKendoRegister, UpdateGridOptions } from './kutils';
import { GetGridOptionSettings, INavGrid, INavGridImp, NavGridOptions } from './navgrid';
import ToDictionary = fn.ToDictionary;
import FindFirst = fn.FindFirst;
import UISafe = fn.UISafe;

/** Grid Options for Items Grid */
export interface INavItemsGridOptions {
    /** Items To Display */
    Source: NavPageClientInfo | IPageMetaData | NavPropertyItems | NavPropertyValue;
    /** NavPropertyItems: Filter to ID's, see NavPropertyItems.GetItems */
    Filter?: string[];
    EditContext?: INavEditContext;

    customDetailCols?: IViewProperty[];
    /** template for the Grid options to use (grouping, ...) */
    baseOptions?: NavGridOptions;
    /** allows for explicit 'ng' - attach on creation */
    $angular?: ng.IScope[];

    Mobile?: boolean;
}

const kendoNavGrid = "kendoNavGrid";
const idms_selcell = "idms_selcell";
const idms_selhead = "idms_selhead";
export class NavItemsGrid extends INavGrid {
    constructor(element, options: INavItemsGridOptions) {
        super(element, createOptions($(element), options));

        // QQQ : we are searching for Grids in this way ... to do ... refactor ....
        // (caution : must be removed on destroy)
        var setData = () => this.element.data(kendoNavGrid, this);
        this.bind(INavGridImp.GridContentCreated, setData);
        setData();

        // those values get set in local function 'createOptions'
        let metaData: IPageMetaData,
            lineProp: IPageProperty,
            initItem: NavPropertyItems,
            propValue: NavPropertyValue,
            releaseSettings: () => void,
            displayColumns: kendo.ui.GridColumn[];

        let grid = this;
        // relase settings on Destroy of grid
        if (releaseSettings)
            grid.one(kconstants.NavDestroy, releaseSettings);

        this.MetaData = metaData;
        this.displayColumns = displayColumns;
        this.LineProp = lineProp;
        this.bind("dataBound", () => this.ApplyMandatory());
        if (this.CurrentItems = initItem) {
            this.attachItem(initItem);
            this.ApplyMandatory();
        }

        if (propValue) {
            // Refresh Items from PropValue
            this.bind(kconstants.NavDestroy, propValue.OnCurrentItemChanged(() => {
                var newItem = propValue.CurrentItem && propValue.CurrentItem.Root.GetLineData(propValue.Property);
                this.SetItems(newItem);
            }));
        }

        /** Handle Vertical cell Navigation */
        var handleUpDownNavigation = (cell: JQuery, e: JQueryEventObject, up: boolean) => {
            var autoComplete = $(":data('kendoNavLookupControl')", cell).data("kendoNavLookupControl");
            if (autoComplete && autoComplete.IsOpen()) // : Navigation must be handleable in list
                return;

            var currentCellIndex = cell.index();
            var nextRow = cell.closest("tr")[up ? "prev" : "next"](kconstants.GridEditRowSelector);
            if (nextRow && nextRow.length > 0) {
                // Select previous row
                grid.clearSelection();
                grid.select(nextRow);

                // Select same cell in next row
                var selectNextOp = nextRow.children("td")[currentCellIndex];
                if (selectNextOp) {
                    selectNextOp.click();
                }
                e.preventDefault();
            }
        };

        // Watch keyboard action
        $(this.element).on("keydown.nav", (e) => {
            var back = e.shiftKey;
            var currentCell = this.element.find(".k-edit-cell");

            switch (e.which) {
                case kendo.keys.TAB:
                    if (this.selectNextEditableCell(currentCell, back))
                        e.preventDefault();
                    break;

                case kendo.keys.UP:
                    handleUpDownNavigation(currentCell, e, true);
                    break;

                case kendo.keys.DOWN:
                    handleUpDownNavigation(currentCell, e, false);
                    break;

                case 119: // 'F8' -> copy value from above
                    const currItems = this.CurrentItems,
                        propPrefix = currItems.MetaData.PropertyName ? currItems.MetaData.PropertyName + '.' : '',
                        xCell = $("#aria_active_cell", grid.tbody),
                        currSelItem = grid.dataItem(xCell.parent()),
                        prevselItem = grid.dataItem(xCell.parent().prev("tr")),
                        col = grid.LeafColumns()[grid.cellIndex(xCell)],
                        currItem = (currItems.GetItems(currSelItem) || [])[0],
                        prevItem = (currItems.GetItems(prevselItem) || [])[0];
                    if (col && col.field && currItem && prevItem) {
                        if (currItem.Root.Anchor.Readonly.GetValue(propPrefix + col.field, currItem) !== true) {
                            UISafe(currItem.SetValue(col.field, prevItem.GetValue(col.field)));
                        }
                    }
                    break;
                default:
                // nothing to do
            }
        });

        //#region Add ToolTip for Explicit HintFields (Initially and after recreate)
        if (typeof $.fn.kendoTooltip == "function") {
            const setupToolTip = () => {
                let ttContent = (currTarget: JQuery) => {
                    var td = currTarget && currTarget.closest("td"),
                        row = td && td.closest("tr"),
                        cellidx = this.cellIndex(currTarget),
                        item = currTarget && grid.dataItem(row),
                        lineInfo = this.CurrentItems,
                        dItem = lineInfo.GetItems(item)[0],
                        col = grid.LeafColumns()[cellidx],
                        field = col && col.field,
                        prop = field && metaData.PropsByName[field],
                        hintPropName = prop && (prop.HintField || prop.Name),
                        hintProp = hintPropName && metaData.PropsByName[hintPropName];
                    return hintProp && dItem && ("" + dItem.GetDisplayValue(hintProp, { FullDecimals: true }));
                };
                var tTip = grid.tbody.kendoTooltip({
                    filter: "td:not(:empty)", // No tooltip for empty field
                    content: function (e) {
                        return $("<div></div>").text(ttContent(e.target)).html();
                    },
                    position: "top"
                }).data("kendoTooltip");
                // Hack : Hide Tooltip wOut Content
                var origShow = tTip["_show"].bind(tTip);
                // Hack force Refresh on ToolTip Content on Value Change
                tTip.one("_ttShow", () => {
                    var refreshTTip = fn.debounce(tTip.refresh.bind(tTip), 250);
                    this.one("SetItems", this.CurrentItems.Anchor.RegisterPropertyChanged(this.LineProp || "*", refreshTTip));
                });
                tTip["_show"] = (t) => {
                    if (!ttContent(t))
                        return;
                    origShow(t);
                    tTip.trigger("_ttShow"); // Allow show Event interception (see above)
                };
            };

            setupToolTip();
            this.bind(INavGridImp.GridContentCreated, setupToolTip);
        }
        //#endregion

        // Patch tab next functionality to rtab over readonly fields ('keydown will be caught by base functionality otherwise')
        var tabNext = grid._tabNext;
        if (tabNext) {
            grid._tabNext = (current, currentTable, back) => {
                var result = tabNext.call(grid, current, currentTable, back);
                if (result && result.length == 1) {
                    var column = grid.LeafColumns()[grid.cellIndex(result)],
                        model = grid._modelForContainer(result);

                    // if not editable reTrigger tab functionality
                    if (column && model && (!model.editable(column.field) || column.infEditable === false))
                        return grid._tabNext(result, currentTable, back);
                }
                return result;
            };
        }

        /** Create Grid Options for base class */
        function createOptions(this: void, element: JQuery, options: INavItemsGridOptions) {
            resolveVars();

            function resolveVars() {
                var source = options.Source;
                let m: IPageMetaData;
                if (source instanceof NavPropertyItems) {
                    metaData = source.MetaData;
                    initItem = source;
                } else if (source instanceof NavPropertyValue) {
                    propValue = source;
                    metaData = source.Property.ArrayProperties;
                    initItem = source.CurrentItem && source.CurrentItem.Root.GetLineData(source.Property);
                } else if (source instanceof NavPageClientInfo) {
                    metaData = (<INavPageClientInfo><any>source).MetaData;
                } else if (source instanceof NavPageMetaData) {
                    metaData = source;
                } else {
                    throw new Error("Invalid Source for NavItemsGrid");
                }
                lineProp = metaData.ParentProperty;
            }

            let customDetailCols = options.customDetailCols,
                editContext = options.EditContext,
                initData = initItem ? (options.Filter ? initItem.GetItems(options.Filter).map(item => item.Model) : initItem.ModelItems) : [],
                properties = metaData.Properties,
                propsByName = ToDictionary(properties, p => p.Name),
                toViewProp = (p: IPageProperty) => { return p && <IViewProperty>{ Name: p.Name, Title: p.Title }; },
                getPropByName = (name: string) => { var result = propsByName[name]; if (!result) { throw new Error("Eigenschaft '" + name + "' nicht vorhanden auf '" + ((lineProp && lineProp.Name) || metaData.PageName) + "'"); }; return result; },
                effectiveParentElement = editContext && editContext.GetAttachedParent() || $(element),
                propCustomDetailCols = lineProp && lineProp.DetailColumns && lineProp.DetailColumns.length && lineProp.DetailColumns,
                columProperties = (customDetailCols && customDetailCols.length ? customDetailCols : (propCustomDetailCols ?
                    propCustomDetailCols.map(p => toViewProp(getPropByName(p))) : // Explicitly Defined
                    properties.filter(item => item.Invisible !== true).map(toViewProp)) // All not explicitly Invisible
                ).filter(f => f && !!f.Name),
                editor = (container: JQuery, _options: kendo.ui.GridColumnEditorOptions) => {
                    var pageLineItem = grid.CurrentItems.GetItems(_options.model)[0];
                    return container.kendoNavCellEditor({ Item: pageLineItem, Property: _options.field, Mobile: options.Mobile });
                },

                /** Displayed columns */
                explicitVisibleCols = fn.ToDictionaryEx(columProperties, c => c.Name, (c, k) => columProperties.indexOf(c)),
                allCols = fn.sort(metaData.Properties.filter(item => item.Invisible !== true || (item.Name in explicitVisibleCols)), c => c.Name in explicitVisibleCols ? explicitVisibleCols[c.Name] : columProperties.length + 1);
            displayColumns = allCols.map(p => {
                var cProp = FindFirst(columProperties, "Name", p.Name);

                var result = metaData.GetColumn(p, { Editable: true, SuppressHint: true });
                result.infEditable = !p.ReadOnly;

                if (cProp) {
                    if (cProp.width && result.width !== cProp.width) {
                        var w = parseInt(("" + cProp.width).replace("px", ""));
                        if (w > 5)
                            result.width = "" + w + "px";
                    }
                    if (cProp.Title)
                        result.title = cProp.Title;
                }

                result.editor = editor;

                switch (p.GridVisibility) {
                    case NavGridVisibility.ForcedVisible:
                    case NavGridVisibility.InitialVisible:
                        result.hidden = false;
                        break;
                    case NavGridVisibility.ForcedRemove:
                        result = undefined;
                        break;
                    case NavGridVisibility.InitialHidden:
                        result.hidden = true;
                        break;
                    default:
                    // nothing to do
                }

                // Hide properties initially not in current Settings
                if (result && columProperties.length > 0) {
                    // Column not in Customization anymore
                    if (!cProp)
                        result.hidden = true;

                    // If hidden state explicitly set, transfer it ...
                    else if (typeof (cProp.hidden) == "boolean")
                        result.hidden = cProp.hidden;
                }

                // TODO : not applicaple for "DesignMode"
                if (result && result.field && !(result.field in explicitVisibleCols))
                    return undefined;
                return result;

            }).filter(fn.isSet);
            // Initialize baseOptions with Out defaults if not set from external
            let baseOptions = <NavGridOptions>$.extend(options.baseOptions || {}, <NavGridOptions>{
                editable: true, //{ mode : "inline"},
                selectable: "multiple",
                mobile: options.Mobile,
                resizable: true,
                reorderable: true,
                sortable: true,
                columnMenu: true,
                navigatable: true, // Use arrow keys to navigate on grid (functionality added)
            });
            if (baseOptions.columns && baseOptions.columns.length) {
                // Ensure no duplicate cols by field name (precedence on baseOptions.Columns ?)
                // but merge 'action' cols from both

                var customColIds = ToDictionary(baseOptions.columns, "field");
                displayColumns = displayColumns.filter(item => !item.field || !customColIds[item.field]);
                displayColumns.unshift(...(baseOptions.columns));
            }

            let gridOptions = <kendo.ui.GridOptions>$.extend(baseOptions, <kendo.ui.GridOptions>{
                dataSource: GetGridDataSource(initData/** ObservableArray for Array Typed Properties! */, metaData.Model, baseOptions),

                change: (e) => {
                    var curr = grid.CurrentItems;
                    if (curr) {
                        grid.selCounter.Wrap(() => {
                            // in 'cell Mode' prepare for "selected Rows"
                            let hasCells = false;
                            let selItems = grid.select().toArray().map(dom => {
                                if (dom.tagName == "TD") {
                                    hasCells = true;
                                    dom = $(dom).parent()[0];
                                }
                                return grid.dataItem(dom);
                            });
                            if (hasCells) {
                                selItems = fn.distinct(selItems);
                            }
                            var column = grid.LeafColumns()[grid.cellIndex(grid.current())];
                            curr.SetSelected(selItems, column && column.field);
                        });
                    }
                },
                columns: displayColumns,
                $angular: options.$angular
            });
            UpdateGridOptions(gridOptions);

            if (!editContext) {
                editContext = {
                    AddDispose: (callback) => {
                        grid.one(kconstants.NavDestroy, callback);
                    },
                    AddSetting: (name, setting) => {
                        var dz = element.closest(":data('INavEditContext')").data('INavEditContext');
                        return (dz && dz.AddSetting(name, setting)) || fn.noop;
                    },
                    GetAttachedParent: () => element
                };
            } else {
                // QQQ External edit Context :  GC Problems WOut reset options?
                editContext.AddDispose(() => {
                    //    this.setOptions({});
                    if (grid) {
                        grid.destroy();
                    }
                });
            }
            // Add User Setting at this point : grid instance not set
            // allows to apply settings on options used for Create iv available:
            // [applying UserSerttings on Created instance will recreate DOM -> Performance]
            releaseSettings = editContext.AddSetting("Grid_" + ((lineProp && lineProp.Name) || metaData.PageName), GetGridOptionSettings(gridOptions, () => grid));
            element.data("INavEditContext", editContext);

            return gridOptions;
        }
    }

    private selCounter = CreateCounter();
    public CurrentItems: NavPropertyItems;

    public MetaData: IPageMetaData;
    /** Set to the Root Property containing the Items, only set for SubProperties */
    public LineProp: IPageProperty;
    private displayColumns: kendo.ui.GridColumn[];

    public SetItems(items: NavPropertyItems, destroy?: boolean) {
        if (this.CurrentItems === items)
            return;

        this.CurrentItems = items;
        this.trigger("SetItems");

        if (items) {
            this.attachItem(items);
        }

        // Not Necessary on Destroy and Performance issue
        if (!destroy) {
            this.dataSource.data((items && items.ModelItems) || []);

            if (items && items.SelectedIds.length > 0)
                SelectIntoView(this, items);
        }
    }

    private attachItem(items: NavPropertyItems) {
        let anchor = items.Anchor,
            mandatory = anchor.Mandatory,
            lineProp = this.LineProp;

        let currProp: IPageProperty = undefined;
        let currHCell = currProp && this.getHeaderCellInfo("");
        let resetHead = fn.noop;
        let resetCells = fn.noop;

        // Register Notifications, to be released upon next SetItems
        var registered = [
            anchor.RegisterPropertyChanged(lineProp || "*", () => this.calculateInvalidLinesCount()),
            anchor.RegisterPropertyChanged(null, (ev) => {
                if (!lineProp || lineProp.Name == (ev.Prop.ParentProp && ev.Prop.ParentProp.Name)) {
                    this.refreshFromModel(ev.Item.Model, ev.Prop.Name);
                    if (mandatory.GetValue(ev.Prop, ev.Item)) {
                        // Refresh Visual Mandatory State
                        var m = <any>{}; m[ev.Prop.Path] = ev.Prop;
                        this.ApplyMandatory(m);
                    }
                }
            }),
            anchor.RegisterPropertyChanged(null, (ev) => {
                if (!lineProp || lineProp.Name == (ev.Prop.ParentProp && ev.Prop.ParentProp.Name)) {
                    this.refreshFromModel(ev.Item.Model, ev.Prop.Name);
                    if (mandatory.GetValue(ev.Prop, ev.Item)) {
                        // Refresh Visual Mandatory State
                        var m = <any>{}; m[ev.Prop.Path] = ev.Prop;
                        this.ApplyMandatory(m);
                    }
                }
            }),
            items.RegisterSelectionChanged(() => {
                if (this.selCounter.IsRunning())
                    return;
                SelectIntoView(this, items);
            }),
            Bind(items, (e: { SelectedProp: IPageProperty }) => {
                if (currProp != e.SelectedProp) {
                    resetHead();
                    currProp = e.SelectedProp;
                    currHCell = currProp && this.getHeaderCellInfo(currProp.Name);
                    if (currHCell) {
                        const hCell = currHCell.Cell;
                        hCell.addClass(idms_selhead);
                        resetHead = fn.once(() => hCell.removeClass(idms_selhead));
                    }
                }

                resetCells();
                if (currHCell && items.SelectionCount > 0) {
                    const cells = items.SelectedItems.map(item => $("td:nth-child(" + currHCell.Index + ")", this.getRowByUid(item.Model.uid)));
                    cells.forEach(c => c.addClass(idms_selcell));
                    resetCells = fn.once(() => cells.forEach(c => c.removeClass(idms_selcell)));
                }
            }, "selectionchanged"),
            () => { resetHead(); resetCells(); },
            mandatory.RegisterChanged(null, info => {
                if ((!lineProp) || (info && info.Property && info.Property.ParentProp == lineProp)) {
                    var arg = <INamed<string>>{}; arg[info.Property.Path] = info.Property.Path;
                    this.ApplyMandatory(arg);
                }
            }),
        ];
        // Deregister on next SetItems Cycle
        this.one("SetItems", fn.combine(registered));
    }

    destroy() {
        if (!this.isSetOptions) {
            this.SetItems(undefined, true);
        }
        this.element.removeData(kendoNavGrid);
        super.destroy();
    }

    public SetReadonly(val: (forInsert) => boolean) {
        var extReadonly = this.extReadonly;
        extReadonly.push(val);
        return fn.once(() => {
            var idx = extReadonly.indexOf(val);
            if (idx >= 0) {
                extReadonly.splice(idx, 1);
            }
        });
    }

    private getReadOnly(forInsert: boolean): boolean {
        return !this.extReadonly.every(getReadonly => !getReadonly(forInsert));
    }
    private readonly extReadonly = new Array<(forInsert: boolean) => boolean>();

    // Apply Changed Mandatory Functionality
    private ApplyMandatory(mandatoryProps?: INamed<string>) {
        let grid = this,
            prefix = grid.LineProp ? grid.LineProp.Path + "." : "",
            lineInfo = grid.CurrentItems;
        grid.calculateInvalidLinesCount();

        if (!lineInfo)
            return;
        mandatoryProps = mandatoryProps || ToDictionary(lineInfo.Anchor.Mandatory.GetItems().filter(item => item.indexOf(prefix) == 0), fn.identity);
        var colInfos = grid.LeafColumns().map((c, idx) => {
            if (mandatoryProps[prefix + c.field]) {
                return {
                    Col: c,
                    Idx: idx + 1, // $ Selector Index : +1
                    Field: prefix + c.field,
                    Invalid: <boolean>undefined,
                };
            }
        }).filter(item => !!item);

        if (colInfos.length == 0 || lineInfo.Count == 0)
            return;

        var rows = $("tr", grid.content).toArray();

        var dataInfo = rows.map((item, idx) => {
            var data = lineInfo.GetItems(grid.dataItem(item))[0];
            return {
                InvalidCols: colInfos.filter(item => data.GetIsInvalid(item.Field)),
                ValidCols: colInfos.filter(item => !data.GetIsInvalid(item.Field)),
                Idx: idx + 1, // $ Selector Index : +1
            };
        });

        dataInfo.forEach(dInfo => {
            var row = $("tr:nth-child(" + (dInfo.Idx) + ") ", grid.content);
            dInfo.InvalidCols.forEach(c => $("td:nth-child(" + c.Idx + ")", row).toggleClass(kconstants.cssInvalid, true));
            dInfo.ValidCols.forEach(c => $("td:nth-child(" + c.Idx + ")", row).toggleClass(kconstants.cssInvalid, false));
        });
    }

    private calculateInvalidLinesCount() {
        if (this.getReadOnly(false))
            return;

        let grid = this,
            lineInfo = this.CurrentItems,
            lineMetaData = grid.MetaData;

        if (this.displayColumns && !this.possInvalidProps)
            this.possInvalidProps = this.displayColumns.map(item => lineMetaData.PropsByName[item.field]).filter(p => p && !p.ReadOnly);

        var result = (lineInfo && lineInfo.Items.map(item => FindFirst(this.possInvalidProps, p => item.GetIsInvalid(p))).filter(fn.isSet).length) || 0;

        if (result != grid["InvalidLinesCount"]) {
            grid["InvalidLinesCount"] = result;
            grid.trigger("InvalidLinesCountChanged", { InvalidLines: result, Lines: (lineInfo && lineInfo.Items.length) || 0 });
        }
        return result;
    }
    private possInvalidProps: IPageProperty[];

    /** Select Next Editable Cell (evtl. skipping to next/previous Row) */
    private selectNextEditableCell(cell: JQuery, back: boolean) {
        let editor = $(cell).parents(".navEditor").first(),
            grid = this,
            lineInfo = this.CurrentItems;
        if (editor) {
            var curCell = grid.element.find(".k-edit-cell"),
                activeCell = grid.element.find("#aria_active_cell"),
                startCell = (curCell.length && curCell) || activeCell,
                next = grid.findNextEditableCell(activeCell, back);
            if (next) {
                var currRow = curCell.parent("tr");

                if (currRow[0] != next.parent("tr")[0]) {
                    grid.clearSelection();
                    grid.select(next.parent("tr")[0]);
                }
                var selectNextOp = getSelectCellOperation(next);
                var selectCurrOp = getSelectCellOperation(curCell);
                curCell.find("input").blur(); // force commit of current edit Item
                //grid.closeCell(); // WOut SetTimout and CloseCell : Changes get not commited (WTF !?!)
                window.setTimeout(() => {
                    // Commit might start (Auto-)Update Operation : defer navigate after Operation
                    this.CurrentItems.Anchor.AfterOperations().then(selectNextOp, selectCurrOp);
                });
            }
            else if (!back && !this.currInsertOp && this.MetaData.CustomInfo.InsertRowMethod && !this.getReadOnly(true)) {
                const createdInserOp = this.currInsertOp = UISafe(lineInfo.InsertNewItem().then((newItem) => {
                    grid.clearSelection();
                    var row = $("tr[data-uid]", grid.content).last(),
                        cell = $("td[role='gridcell']", row).filter(":visible").first();
                    lineInfo.SetSelected(newItem);
                    cell.click();
                }));
                const resetInsertOp = () => { if (this.currInsertOp === createdInserOp) { this.currInsertOp = null; } };
                createdInserOp.then(resetInsertOp, resetInsertOp);
                return false; // "true" would prevent commit of currently edited item
            }
        }
        return !!next;

        /** Determine a Delegate to restore "Same" Cell in Grid after Possible Reload of DOM */
        function getSelectCellOperation(td: JQuery) {
            var cellidx = grid.cellIndex(td);
            var field = grid.LeafColumns()[cellidx];
            var model = lineInfo.GetItems(grid.dataItem(td.parent("tr")))[0];
            if (!(field && model))
                return fn.noop;

            return () => {
                var row = FindFirst(grid.items(), item => model.IsMatch(grid.dataItem(item)));
                if (row) {
                    var col = $("td[role=gridcell]", row)[cellidx];
                    if (col) {
                        let cell = $(col);
                        grid.current(cell);
                        cell.click();
                    }
                }
            };
        }
    }
    private currInsertOp: PromiseLike<void>;
}
NavKendoRegister(NavItemsGrid, "NavItemsGrid", {});

/** Scroll and page selection on kendo grid into view */
export function SelectIntoView(grid: INavGrid, lineInfo: NavPropertyItems) {
    var data = lineInfo.GetItems(lineInfo.SelectedIds).map(item => item.Model);

    // Selected items in current (paged) view
    var dataInView = grid.dataSource.view().filter(item => {
        var key = lineInfo.GetKey(item, true);
        return lineInfo.SelectedIds.indexOf(key) >= 0;
    });

    // TODO : Refactor : do not Clear Selection if not necessay !!!
    // Selection not found in view (paging)?

    if (data.length > 0 && dataInView.length == 0) {
        grid.clearSelection();
        // Find first page with selection
        var maxPageSize = grid.dataSource.totalPages();

        for (var i = 1; i <= maxPageSize; i++) {
            // Increment pages
            grid.dataSource.page(i);

            // Is selected row on current page?
            var dataOfSelectionInView = grid.dataSource.view().filter(item => {
                var key = lineInfo.GetKey(item, true);
                return lineInfo.SelectedIds.indexOf(key) >= 0;
            });

            if (dataOfSelectionInView.length > 0) {
                // At least one selected data item found in view
                // -> Get selected rows in view
                var rowsInView = grid.items().filter((i, el) => {
                    var currItem = grid.dataItem(el);
                    var currSelitems = dataOfSelectionInView.filter(cel => cel["Key"] == currItem["Key"]);
                    return currSelitems.length > 0;
                });

                if (rowsInView.length > 0) {
                    // Select rows in view
                    grid.select(rowsInView);

                    // Scroll first selected item into view
                    var top = rowsInView.first().offset().top;
                    grid.content.scrollTop(top);

                    // Stay on current page
                    break;
                }
            }
        }
    } else {
        // All rows to be selected
        let rowsToSelect = grid.items().filter((i, el) => {
            var item = grid.dataItem(el);
            var key = lineInfo.GetKey(item, true);
            return lineInfo.SelectedIds.indexOf(key) >= 0;
        });

        // "clearSelection" will trigger "change", as will "select" if any to select
        // so clear wOut Notification, if we will select rows
        if (rowsToSelect.length == 0)
            grid.clearSelection();
        else {
            grid.selectable.clear();
            // select
            grid.select(rowsToSelect);
        }
    }
}

/** Get kendo grid options including datasource and metadata */
export function GetGridOptions(displayData: any[] | IObservableArray, arrMeta: IPageMetaData, templateColumns?: INamed<kendo.ui.GridColumn>) {
    let arrProp = arrMeta && arrMeta.ParentProperty,
        metaProps = (arrMeta && arrMeta.Properties) || [],
        data = GetGridDataSource(displayData, arrMeta && arrMeta.Model),
        columns = metaProps.filter(p => p.Invisible != true).map(p => arrMeta.GetColumn(p)),
        options: NavGridOptions = {
            dataSource: data,
            reorderable: true,
            sortable: {},
            columnMenu: { filterable: false },
            resizable: true,
            selectable: 'row',
            columns: columns
        };

    // apply template colum properties
    if (templateColumns) {
        columns.forEach(col => {
            var configColumn = templateColumns[col.field];
            if (configColumn) {
                $.extend(col, configColumn);
            }
        });
    }
    return options;
}
